module.exports = __webpack_public_path__ + "static/media/moore.7fcc0592.png";